// Persistent dashboard snapshot used to make TWA/PWA cold-resume feel
// instant. Cloudflare sends `Cache-Control: no-store` on /dashboard, which
// disqualifies the page from Chrome's Back-Forward Cache (BfCache). That
// means every time the user backgrounds and resumes the TWA, the WebView
// performs a full reload and the user sees the "Loading your bookmarks…"
// loader for 1-3 seconds. By snapshotting the dashboard state to
// localStorage we can render the previous view immediately on next launch
// while a background refresh runs silently.
//
// Cache is tied to the logged-in user's email so a different account on
// the same device can never see another user's bookmarks.

const CACHE_KEY = 'bs_dashboard_cache_v1';
// Industry-standard BfCache lifetime is ~10 min; we mirror that so users
// who return within a typical app-switch window get an instant view.
const CACHE_TTL_MS = 10 * 60 * 1000;

export function readDashboardCache() {
    try {
        const raw = localStorage.getItem(CACHE_KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        if (!data || typeof data !== 'object' || !data.timestamp || !data.email) return null;
        if (Date.now() - data.timestamp > CACHE_TTL_MS) return null;
        const savedEmail = localStorage.getItem('brainsync_user_email');
        // Only trust the cache if the marker matches - different account
        // on the same device must not see stale bookmarks from another.
        if (!savedEmail || savedEmail !== data.email) return null;
        return data;
    } catch (_) {
        return null;
    }
}

export function writeDashboardCache(snapshot) {
    try {
        const payload = { ...snapshot, timestamp: Date.now() };
        localStorage.setItem(CACHE_KEY, JSON.stringify(payload));
    } catch (_) {
        // Quota exceeded or storage disabled - silently ignore. The next
        // fetch path still works without the cache.
    }
}

export function clearDashboardCache() {
    try { localStorage.removeItem(CACHE_KEY); } catch (_) {}
}
